<template>
  <div >
      <valid-van-field class="term"
        v-model="commonInputs[model]"
        :label="label"
        center
        :placeholder="placeholder"
        :rules="reg"
        maxlength="6"
        type="number"
        >
        <button
          slot="button"
          id="buttonStyle"
          :disabled="disabled"
          @click="sendcode"
          >{{ messageButton }}</button>
          </valid-van-field>
  </div>
</template>

<script>
// @ is an alias to /src

import { Field, Toast } from 'vant';
import service from '@/request/api'; // 导入api接口
import ValidHoc from '../../../../components/valid';

const ValidVanField = ValidHoc(Field);
export default {
  name: 'MessageCode',
  components: {
    ValidVanField,
  },
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      commonInputs: {
        [this.model]: this.$store.state.commonForms[this.model],
      },
    };
  },
  props: [
    'label',
    'model',
    'placeholder',
    'reg',
    'IsInterface',
  ],
  watch: {
    commonInputs: {
      // eslint-disable-next-line no-unused-vars
      handler(value, oldValue) {
        this.$store.commit('commonForms/updateForm', {
          [this.model]: value[this.model],
        });
      },
      deep: true,
    },
  },
  created() {
    console.log(this.$store.state.commonForms);
    console.log(this.model);
  },
  mounted() {
    this.commonInputs[this.model] = '';
  },
  methods: {
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `${this.time}s后获取`;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
      }
    },
    sendcode() {
      if (!this.$store.state.commonForms.legalPhone) {
        Toast('电话号码不能为空');
        return;
      }
      let fn = 'getMessageCode';
      this.disabled = true;
      const params = {
        phone: this.$store.state.commonForms.legalPhone,
        type: this.$store.state.commonForms.captchaType,
      };
      if (this.IsInterface) {
        fn = 'getBankMessageCode';
        delete params.type;
        delete params.phone;
        params.cust_mobile = this.$store.state.commonForms.legalPhone;
      }
      service.CommonForms[fn](params)
        .then((res) => {
          if (!res.success) {
            Toast({
              message: res.returnMessage,
              forbidClick: true, // 背景不可点击
            });
            this.disabled = false;
          } else {
            this.time = 60;
            this.timer();
          }

          console.log(res);
        }).catch((e) => {
          console.log(e);
          this.disabled = false;
        });
    },
  },
};
</script>
<style >
.bgColor {
  background: #f8f8f9;
}
.van-button--small {
    min-width: 60px;
    height: 30px;
    padding: 0 8px;
    color: #F65846;
    font-size: 12px;
    line-height: 28px;
    background-color: #fff;
}

.buttonDe{
    margin: 0;
    color: #ccc;
    font-size: 14px;
    outline:none;
}
#buttonStyle {
    margin: 0;
    padding: 0;
    color: #F65846;
    font-size: 14px;
    background: #fff;
    border: 1px solid transparent;
    outline: none;
}
.term::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #DDDEE1;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
    content: ' ';
    pointer-events: none;
}
</style>
